module.exports = __webpack_public_path__ + "media/images/bnr-early-lg-26e69999a6413b338aa684e0b005be5f.png";